<template>
  <div v-if="show" :class="`secondPopup ${colorClass} active`">
    <div class="iconArea"></div>
    <p v-html="contents"></p>
    <div class="exit" @click.stop="onClickClose"></div>
  </div>
</template>

<script setup lang="ts">
import {ref, computed, convertToNextLine} from '#imports';
import {ToastType} from "~/components/Common/Toast/model/ToastType";
import {useToastStore} from "~/store/toast/toastStore";
import type {ToastStoreStateOption} from "~/store/toast/state";

const toastStore = useToastStore();
const show = ref(false);
const options = ref({} as ToastStoreStateOption);
const timeoutId = ref<NodeJS.Timeout>();

toastStore.$subscribe((mutation, state) => {
  show.value = state.show;
  options.value = state.options;
});

onMounted(() => {
  show.value = toastStore.show;
  options.value = toastStore.options;

  if (show.value) setPopupTime();
})

const isTwoLine = computed(() =>
    toastStore.options.contents.includes("\n")
);

const contents = computed(() => {
  if (isTwoLine) return convertToNextLine(toastStore.options.contents);
  else return toastStore.options.contents;
});

const colorClass = computed(() => {
  switch (toastStore.options.toastType) {
    case ToastType.SUCCESS: return "green";
    case ToastType.INFO: return "blue";
    case ToastType.WARNING: return "orange"
    default: return "red";
  }
});

const setPopupTime = () => {
  timeoutId.value = setTimeout(onClickClose, 7000);
}

watch(() => show.value, () => {
  if (show.value) setPopupTime();
});

const onClickClose = () => {
  clearTimeout(timeoutId.value);
  options.value.close?.event();
  toastStore.closeToast();
}
</script>
